import './ImageGallery.css';
import { React, PropTypes, useEffect, useState, Carousel } from '../../libraries';
import { DefaultShop } from '../../assets/Images';
import { useRef } from 'react';

const CustomImage = React.lazy(() => import('../../common/image/image'));
const ImageGallery = ({ images,tag }) => {
  const [expandedImgSrc, setExpandedImgSrc] = useState(
    images && images.length > 0 ? images[0] : DefaultShop,
  );
  const [clickSideImage, setClickSideImg] = useState(false);

  const [carouselIndex, setCarouselIndex] = useState(0);

  const handleImageClick = (src, index) => {
    setClickSideImg(true);
    setExpandedImgSrc(src);
    setCarouselIndex(index);
  };

  const handleCarouselChange = (current) => {
    setClickSideImg(false);
    setExpandedImgSrc(images[current]);
    setCarouselIndex(current);
  };

  useEffect(() => { }, [expandedImgSrc])

  const tagSectionRef = useRef(null);
  const [columns, setColumns] = useState(1);

  useEffect(() => {
    if (!tagSectionRef.current) return;

    const imageHeight = tagSectionRef.current.parentElement.offsetHeight;
    const tagsHeight = tagSectionRef.current.scrollHeight;

    if (tagsHeight > imageHeight) {
      setColumns(2);
    } else {
      setColumns(1);
    }
  }, [tag]);

  const tagsArray = tag ? tag.split(",").map(t => t.trim()) : [];

  // Split for 2 columns if needed
  const mid = Math.ceil(tagsArray.length / 2);
  const leftTags = columns === 2 ? tagsArray.slice(0, mid) : tagsArray;
  const rightTags = columns === 2 ? tagsArray.slice(mid) : [];

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div>
      {images.length >= 1 ? (
        <>
          {windowWidth > 574 ? (
            <div className="row  search-display-desc-outer-div">
              <div className="col-2 side-small-img">
                {images.map((image, index) => (
                  <div className="column" key={index}>
                    <img
                      alt="Gallery"
                      className=""
                      src={image}
                      onClick={() => handleImageClick(image, index)}
                    />
                  </div>
                ))}
              </div>

              <div className="col-10" id="carousel-inner-div">
                <Carousel
                  arrows
                  infinite={true}
                  initialSlide={carouselIndex}
                  afterChange={handleCarouselChange}
                  arrowSize={24}
                  dots={false}
                >
                  {images.map((image, index) => (
                    <div key={index}>
                      <img
                        alt="Gallery"
                        id="expandedImg"
                        className="active w-100"
                        src={clickSideImage ? expandedImgSrc : image}
                      />
                    </div>
                  ))}
                </Carousel>
                {tag && (
                  <div className="tag-section-organization-details" ref={tagSectionRef}>
                    <div className="tag-columns ms-3">
                      <div className="tag-column">
                        {leftTags.map((t, i) => (
                          <span key={i} className="tag-item">{t}</span>
                        ))}
                      </div>
                      {columns === 2 && (
                        <div className="tag-column">
                          {rightTags.map((t, i) => (
                            <span key={i} className="tag-item">{t}</span>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
          ) : (
            <div className="search-display-desc-outer-div-mobile search-display-desc-outer-div">
              <div id="carousel-inner-div">
                <div id="carousel-inner-div">
                  <Carousel
                    arrows
                    infinite={true}
                    initialSlide={carouselIndex}
                    afterChange={handleCarouselChange}
                    arrowSize={24}
                    dots={false}
                  >
                    {images.map((image, index) => (
                      <div key={index}>
                        <img
                          alt="Gallery"
                          id="expandedImg"
                          className="active w-100"
                          src={clickSideImage ? expandedImgSrc : image}
                        />
                      </div>
                    ))}
                  </Carousel>

                  {tag && (
                    <div className="tag-section-organization-details" ref={tagSectionRef}>
                      <div className="tag-columns ms-3">
                        <div className="tag-column">
                          {leftTags.map((t, i) => (
                            <span key={i} className="tag-item">{t}</span>
                          ))}
                        </div>
                        {columns === 2 && (
                          <div className="tag-column">
                            {rightTags.map((t, i) => (
                              <span key={i} className="tag-item">{t}</span>
                            ))}
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <div className="side-small-img mt-3">
                {images.map((image, index) => (
                  <div className="column" key={index}>
                    {index < 4 && (
                      <img
                        alt="Gallery"
                        className="gallery-image"
                        src={image}
                        onClick={() => handleImageClick(image, index)}
                      />
                    )}
                  </div>
                ))}
              </div>
            </div>
          )
          }
        </>
      ) : (
        <>
          <div className="single-shop-img">
            <CustomImage
              alt="Gallery"
              id="expandedImg"
              className="active image-gallery-single-img"
              src={expandedImgSrc || DefaultShop}
              width={'unset'}
              height={'unset'}
            />

            {tag && (
              <div className="tag-section-organization-details" ref={tagSectionRef}>
                <div className="tag-columns">
                  <div className="tag-column">
                    {leftTags.map((t, i) => (
                      <span key={i} className="tag-item">{t}</span>
                    ))}
                  </div>
                  {columns === 2 && (
                    <div className="tag-column">
                      {rightTags.map((t, i) => (
                        <span key={i} className="tag-item">{t}</span>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
};

ImageGallery.propTypes = {
  images: PropTypes.arrayOf(PropTypes.string),
};

export default ImageGallery;